import $ from 'jquery';

export default class abgrcs_config {
	site_url;
	static user_inf;
	static service_array = [
		{
			single_name : "Product Photography",
			single_img : "/uploads/cat_1/img_1.jpg",
			single_img_more : [
				{
					image_url : "/uploads/cat_1/img_1.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_2.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_3.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_4.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_5.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_6.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_7.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_8.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_9.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_10.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_11.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_12.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_13.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_14.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_15.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_16.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_17.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_18.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_19.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_20.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_21.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_22.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_23.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_24.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_25.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_26.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_27.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_28.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_29.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_30.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_31.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_32.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_33.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_34.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_35.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_36.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_37.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_38.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_39.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_40.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_41.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_42.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_43.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_44.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_45.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_46.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_47.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_48.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_49.jpg",
					image_description : "Product Photography"
				},
				{
					image_url : "/uploads/cat_1/img_50.jpg",
					image_description : "Product Photography"
				}
			]
		},
		{
			single_name : "Real Estate & Hotels Photography",
			single_img : "/uploads/cat_2/img_1.jpg",
			single_img_more : [
				{
					image_url : "/uploads/cat_2/img_1.jpg",
					image_description : "Real Estate & Hotels Photography"
				},
				{
					image_url : "/uploads/cat_2/img_2.jpg",
					image_description : "Real Estate & Hotels Photography"
				},
				{
					image_url : "/uploads/cat_2/img_3.jpg",
					image_description : "Real Estate & Hotels Photography"
				},
				{
					image_url : "/uploads/cat_2/img_4.jpg",
					image_description : "Real Estate & Hotels Photography"
				},
				{
					image_url : "/uploads/cat_2/img_5.jpg",
					image_description : "Real Estate & Hotels Photography"
				},
				{
					image_url : "/uploads/cat_2/img_6.jpg",
					image_description : "Real Estate & Hotels Photography"
				},
				{
					image_url : "/uploads/cat_2/img_7.jpg",
					image_description : "Real Estate & Hotels Photography"
				},
				{
					image_url : "/uploads/cat_2/img_8.jpg",
					image_description : "Real Estate & Hotels Photography"
				},
				{
					image_url : "/uploads/cat_2/img_9.jpg",
					image_description : "Real Estate & Hotels Photography"
				},
				{
					image_url : "/uploads/cat_2/img_10.jpg",
					image_description : "Real Estate & Hotels Photography"
				},
				{
					image_url : "/uploads/cat_2/img_11.jpg",
					image_description : "Real Estate & Hotels Photography"
				},
				{
					image_url : "/uploads/cat_2/img_12.jpg",
					image_description : "Real Estate & Hotels Photography"
				},
				{
					image_url : "/uploads/cat_2/img_13.jpg",
					image_description : "Real Estate & Hotels Photography"
				},
				{
					image_url : "/uploads/cat_2/img_14.jpg",
					image_description : "Real Estate & Hotels Photography"
				},
				{
					image_url : "/uploads/cat_2/img_15.jpg",
					image_description : "Real Estate & Hotels Photography"
				},
				{
					image_url : "/uploads/cat_2/img_16.jpg",
					image_description : "Real Estate & Hotels Photography"
				}
			]
		},
		{
			single_name : "Portrait & Fashion Photography",
			single_img : "/uploads/cat_3/img_1.jpg",
			single_img_more : [
				{
					image_url : "/uploads/cat_3/img_1.jpg",
					image_description : "Portrait & Fashion Photography"
				},
				{
					image_url : "/uploads/cat_3/img_2.jpg",
					image_description : "Portrait & Fashion Photography"
				},
				{
					image_url : "/uploads/cat_3/img_3.jpg",
					image_description : "Portrait & Fashion Photography"
				},
				{
					image_url : "/uploads/cat_3/img_4.jpg",
					image_description : "Portrait & Fashion Photography"
				},
				{
					image_url : "/uploads/cat_3/img_5.jpg",
					image_description : "Portrait & Fashion Photography"
				},
				{
					image_url : "/uploads/cat_3/img_6.jpg",
					image_description : "Portrait & Fashion Photography"
				},
				{
					image_url : "/uploads/cat_3/img_7.jpg",
					image_description : "Portrait & Fashion Photography"
				},
				{
					image_url : "/uploads/cat_3/img_8.jpg",
					image_description : "Portrait & Fashion Photography"
				},
				{
					image_url : "/uploads/cat_3/img_9.jpg",
					image_description : "Portrait & Fashion Photography"
				},
				{
					image_url : "/uploads/cat_3/img_10.jpg",
					image_description : "Portrait & Fashion Photography"
				},
				{
					image_url : "/uploads/cat_3/img_11.jpg",
					image_description : "Portrait & Fashion Photography"
				},
				{
					image_url : "/uploads/cat_3/img_12.jpg",
					image_description : "Portrait & Fashion Photography"
				},
				{
					image_url : "/uploads/cat_3/img_13.jpg",
					image_description : "Portrait & Fashion Photography"
				}
			]
		},
		{
			single_name : "Beauty Photography",
			single_img : "/uploads/cat_4/img_1.jpg",
			single_img_more : [
				{
					image_url : "/uploads/cat_4/img_1.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_2.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_3.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_4.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_5.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_6.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_7.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_8.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_9.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_10.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_11.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_12.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_13.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_14.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_15.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_16.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_17.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_18.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_19.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_20.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_21.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_22.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_23.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_24.jpg",
					image_description : "Beauty Photography"
				},
				{
					image_url : "/uploads/cat_4/img_25.jpg",
					image_description : "Beauty Photography"
				}
			]
		}
	];

	constructor() {
		this.site_url = "http://localhost/projects/app-int-journals/app-int";
	}

	static getCookie(name) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) return parts.pop().split(';').shift();
	}
	
	static create_cookie(name, value, days)
	{
	  if (days)
	  {
		var date = new Date();
		date.setTime(date.getTime()+(days*24*60*60*1000));
		var expires = "; expires="+date.toGMTString();
	  }
	  else
		var expires = "";
	  
	  document.cookie = name + " = " + value + "; expires = " + expires + ";";
	}

	static eraseCookie(name) {   
		document.cookie = name+'=; Max-Age=-99999999; path=/';  
	}
}

if( true )
{
	abgrcs_config.site_url = "https://appintjournals.cleverapps.io";
}